import React from "react";
import {
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from "@mui/material";

const BodyComposition = ({
  formData,
  handleInputChange,
  handleBooleanChange,
}) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="body1">
          Avez-vous mesuré votre pourcentage de graisse corporelle ?
        </Typography>
        <RadioGroup
          row
          name="pourcentageGraisseCorporelle"
          value={formData.pourcentageGraisseCorporelle ? "true" : "false"} // Convert boolean to string
          onChange={handleBooleanChange} // Pass event handler directly
        >
          <FormControlLabel value="true" control={<Radio />} label="Oui" />
          <FormControlLabel value="false" control={<Radio />} label="Non" />
        </RadioGroup>
      </Grid>
      {formData.pourcentageGraisseCorporelle && (
        <>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Pourcentage Masse Grasse (%)"
              name="pourcentageMasseGrasse"
              type="number"
              value={formData.pourcentageMasseGrasse}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Outil Utilisé"
              name="masseGrasseOutil"
              value={formData.masseGrasseOutil}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default BodyComposition;
